import React, { useEffect, useRef, useState } from "react";
import { Megaphone, X, Radio } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

// Pop-up broadcast notifications for signed-in users — polls every 60s and on window focus
export default function BroadcastPopup({ currentUser }) {
  const [items, setItems] = useState([]);
  const timer = useRef(null);

  const load = () => {
    if (!currentUser?.real) return;
    fetch(`${API}/api/broadcasts/active`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => setItems(Array.isArray(data) ? data : []))
      .catch((err) => console.debug("broadcast poll skipped", err));
  };

  useEffect(() => {
    load();
    timer.current = setInterval(load, 3000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => {
      clearInterval(timer.current);
      window.removeEventListener("focus", onFocus);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.real]);

  const dismiss = (id) => {
    setItems((prev) => prev.filter((b) => b.id !== id));
    fetch(`${API}/api/broadcasts/${id}/dismiss`, { method: "POST", credentials: "include" }).catch((err) => console.debug("dismiss failed", err));
  };

  if (!items.length) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[60] space-y-3 w-[calc(100vw-2rem)] max-w-sm" data-testid="broadcast-popup-stack">
      {items.map((b) => (
        <div
          key={b.id}
          className="bg-white border border-[#F8C8DC] rounded-3xl shadow-[0_20px_50px_-15px_rgba(248,200,220,0.9)] p-5 animate-fade-up dark:bg-[#273244] dark:border-[#374457]"
          data-testid={`broadcast-popup-${b.id}`}
        >
          <div className="flex items-start gap-3">
            <span className="w-9 h-9 rounded-full bg-[#FCE6E9] flex items-center justify-center shrink-0">
              <Megaphone className="w-4 h-4 text-[#E5A0BC]" />
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-black font-heading text-[#374151] dark:text-slate-100">{b.title}</p>
              <p className="text-xs text-[#6B7280] dark:text-slate-300 mt-1 leading-relaxed">{b.message}</p>
              {b.link && (
                <button
                  onClick={() => {
                    dismiss(b.id);
                    window.location.assign(b.link);
                  }}
                  data-testid={`broadcast-watch-${b.id}`}
                  className="mt-3 inline-flex items-center gap-1.5 px-4 py-2 bg-rose-500 hover:bg-rose-600 text-white text-[11px] font-extrabold rounded-full shadow-sm transition-colors"
                >
                  <Radio className="w-3.5 h-3.5" /> Watch Live
                </button>
              )}
              <p className="text-[9px] text-[#9CA3AF] font-bold uppercase tracking-wider mt-2">NestTrack announcement</p>
            </div>
            <button
              onClick={() => dismiss(b.id)}
              data-testid={`broadcast-dismiss-${b.id}`}
              className="w-7 h-7 rounded-full bg-[#FFF9F2] hover:bg-[#FCE6E9] flex items-center justify-center text-[#9CA3AF] hover:text-[#374151] shrink-0 transition-colors"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
